import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotifyToasterService } from '../services/toaster/notify-toaster.service';
import { AVOID_SHOWING_ERROR_MESSAGE } from '../constants/constants';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly notificationsService: NotifyToasterService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
    .pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          errorMessage = `Error: ${error.error?.message}`;
        } else {
          errorMessage = `${error.error?.error?.message}`;
        }
        
        if(errorMessage != AVOID_SHOWING_ERROR_MESSAGE)
          this.notificationsService.showError(errorMessage);
        
        return throwError(() => error);
      })
    );
  }
}